import { render, staticRenderFns } from "./GroupHome.vue?vue&type=template&id=315662ae&scoped=true&"
import script from "./GroupHome.vue?vue&type=script&lang=js&"
export * from "./GroupHome.vue?vue&type=script&lang=js&"
import style0 from "./GroupHome.vue?vue&type=style&index=0&id=315662ae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315662ae",
  null
  
)

export default component.exports